import { render, staticRenderFns } from "./contractIts.vue?vue&type=template&id=46c2150a&scoped=true&"
import script from "./contractIts.vue?vue&type=script&lang=js&"
export * from "./contractIts.vue?vue&type=script&lang=js&"
import style0 from "./contractIts.vue?vue&type=style&index=0&id=46c2150a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46c2150a",
  null
  
)

export default component.exports